// extracted by mini-css-extract-plugin
export default {"input":"Input_input__Q4jF3","label":"Input_label__i2WvA","number":"Input_number__vShwi","button":"Input_button__5jhfR"};